/* eslint-disable max-classes-per-file */
/* eslint-disable class-methods-use-this */
import {
  DefaultNodeModel,
  PortModelAlignment,
} from "@projectstorm/react-diagrams";
import { toast } from "react-toastify";
import ComponentPortModel from "./ComponentPortModel";

export default class ComponentNodeModel extends DefaultNodeModel {
  static type = "component";

  constructor(options) {
    super({
      ...options,
      type: "component",
    });

    this.addPort(
      new ComponentPortModel({
        name: "In",
        alignment: PortModelAlignment.TOP,
        in: true,
      })
    );

    this.addPort(
      new ComponentPortModel({
        name: "Left",
        alignment: PortModelAlignment.LEFT,
      })
    );
    this.addPort(
      new ComponentPortModel({
        name: "Right",
        alignment: PortModelAlignment.RIGHT,
      })
    );
    this.addPort(
      new ComponentPortModel({
        name: "Out",
        alignment: PortModelAlignment.BOTTOM,
      })
    );
  }

  getParentPorts() {
    return Object.values(this.getPort("In")?.links ?? {}).map(
      (link) => link.sourcePort
    );
  }

  getChildrenTypes() {
    return Object.values(this.getPort("Out")?.links ?? {})
      .concat(Object.values(this.getPort("Failed")?.links ?? [])) // get links from both ports
      ?.map((link) => link.targetPort?.parent.type ?? null)
      .filter((item) => item !== null);
  }

  remove(isAllowed) {
    // check if remove is allowed
    if (!isAllowed) {
      toast.error("Please remove the node using delete button");
      return false;
    }

    // check if node is connected
    if (
      Object.values(this.ports)
        .map((port) => Object.values(port.links))
        .flat().length > 0
    ) {
      toast.error(
        "You cannot remove a node that is connected. Disconnect node first."
      );
      return false;
    }

    super.remove();
    return true;
  }

  serialize() {
    return {
      ...super.serialize(),
      componentID: this.options.componentID,
      component: this.options.component,
    };
  }

  deserialize(event) {
    super.deserialize(event);
    this.options.componentID = event.data.componentID;
    this.options.component = event.data.component;
  }
}
